import { checkToken } from './checkToken';

const redirectToPageBasedOnTypeOfUser = () => {
  const [isAuthenticated, user] = checkToken();
  if (isAuthenticated) {
    if (user.typeOfUser === 'admin') {
      return '/propiedades';
    } else if (user.typeOfUser === 'collab') {
      return '/perfil';
    } else if (user.typeOfUser === 'cucicba') {
      return '/usuarios/matriculados';
    } else if (user.typeOfUser === 'stats') {
      return '/estadisticas';
    }
  } else {
    return '/ingresar';
  }
};

export default redirectToPageBasedOnTypeOfUser;
